import type { CostAdjustmentEditable } from "../../../api_utils/types";
import { assertNumber } from "../../../helper_functions/utils";

export function calculateCostAdjustmentAmount(costAdjustment: CostAdjustmentEditable, lineTotal: number): number {
  if (costAdjustment._destroy) return 0;

  const amount = formatCostAdjustmentAmount(costAdjustment);
  return costAdjustment.amount_type === "percentage" ? (lineTotal * amount) / 100 : amount;
}

export function formatCostAdjustmentAmount(costAdjustment: CostAdjustmentEditable): number {
  const amount = assertNumber(costAdjustment.amount);
  return costAdjustment.label === "Discount" ? -Math.abs(amount) : amount;
}
